import { Component, OnInit, Input } from "@angular/core";
import { AngularFireDatabase } from "angularfire2/database";
import * as lodash from "lodash";
import { Subject, Subscription } from "rxjs";
import * as moment from 'moment'
import { OAuthService } from "app/services/o-auth";
import { ActivatedRoute } from "@angular/router";
import { ApiService } from "app/services/api";

@Component({
  selector: "app-post",
  templateUrl: "./post.component.html",
  styleUrls: ["./post.component.scss"],
})
export class PostComponent implements OnInit {
  @Input() post: any;
  @Input() likes: any;
  @Input() comments: any;

   club;
  allComments = [];
  comment: string = "";
  mentionedInComment = {}
  likesSubscription: Subscription;
  public parentSubject: Subject<any> = new Subject();
  public parentSubjectEdit: Subject<any> = new Subject();

  queryParams = {};
  isPostLikedByCurrentUser: boolean = false;
  show: boolean = false;
  
  postId;
  authorId;
  postAuthor;

  openToggle;
  public mentioned: Array<{ id: string; username: string }>;

  constructor(
    private fireData: AngularFireDatabase,
    private oAuthService: OAuthService,
    private route: ActivatedRoute,
    public apiService: ApiService,
  ) {
    this.mentioned = [];
  }

  ngOnInit() {
    this.club = this.oAuthService.getClub();
    this.post = undefined;
    this.authorId = this.route.snapshot.paramMap.get('author');
    this.postId = this.route.snapshot.paramMap.get('id');
    this.fireData.database.ref(`/users-posts/${this.authorId}/${this.postId}`).on("value", async result => {
      this.post = result.val();
      this.postAuthor = await this.apiService.object(`/users/${this.authorId}`);
      lodash.forEach(this.post.mentioned, (element, key) => {
        let user = { id: key, username: element.username }
        this.mentioned.push(user);
      });
      this.loadData()
    })
  }

  showToggle(i){
    this.show = true;
    this.openToggle = i;
  }
  
  closeToggle(){
    this.show = false;
  }

  loadData()
  {
    this.loadComments();
    this.loadLikes();
    if (this.post.likesCount)
    {
      this.fireData.object(`/posts/${this.postId}/likes/${this.club.cid}`).subscribe(result => {
        let isLiked = result.$value
        if (isLiked == this.post.author)
        {
          this.isPostLikedByCurrentUser = true;
        }
        else {
          this.isPostLikedByCurrentUser = false;
        }
      })
    }
    else {
      this.isPostLikedByCurrentUser = false;
    }
    
  }



  formateDate(timestamp)
  {
    return moment.unix(timestamp).fromNow()
  }

  formateDateComment(timestamp)
  {
    return moment.unix(timestamp).fromNow()
  }

  numFormatter(num)
  {
    if(num > 999 && num < 1000000){
        return (num/1000).toFixed(1) + 'K'; 
    }else if(num > 1000000){
        return (num/1000000).toFixed(1) + 'M'; 
    }else if(num < 900){
        return num;
    }
  }

  async loadComments()
  {
    this.fireData.database.ref(`/posts/${this.postId}/comments`).on("value", async (allcomments) => {

      if (allcomments.val())
      {
        let commentss = []
        for (let key of Object.keys(allcomments.val()))
        {
          let element = allcomments.val()[key];
          Object.assign(element, { $key: key });
          commentss.push(element);
        }

        let comments = []
        
        for (let i = 0; i < commentss.length; i++)
        {
          let comment = commentss[i];
          let author = await this.apiService.object(`/users/${comment.author}`);
          if (author.$exists())
          {
            Object.assign(comment, { author_avatar: author.avatar ? author.avatar: author.avatar_thumb, author_name: author.fullName, author_website: author.websiteLink });
            this.comments.push()
            comments.push(comment);
          }
          
        }
      
        comments.sort((a, b) => {
          return (new Date(b.date)).valueOf() - (new Date(a.date)).valueOf();
        });
        this.allComments = comments;
      }
      else 
        this.allComments = [];
      
    });
  }

   getTabName(user)
  {
    if (user.username)
      return user.username
    else if (user.fullName)
      return user.fullName
    else if (user.firstName)
      return user.firstName
    else if (user.name)
      return user.name
    else if (user.lastName)
      return user.lastName
    else return "unknown user"
  }


  async loadLikes()
  {
    this.fireData.database.ref(`/posts/${this.postId}/likes`).on("value",async  (alllikes) => {
      
      if (alllikes.val())
      {

        let llikes = []
        for (let key of Object.keys(alllikes.val()))
        {
          llikes.push(key);
          
        }

        let likes = []
        for (let i = 0; i < llikes.length; i++)
        {
          let like = llikes[i];
          let author = await this.apiService.object(`/users/${like}`);
          if(author.$exists())
          {
            likes.push(author);
          }
        }

        likes.sort((a, b) => {
          return (new Date(b.date)).valueOf() - (new Date(a.date)).valueOf();
        });
        this.likes = likes
      } else this.likes = [];
      
    });
  }

  isLikeClickable: boolean = true;

  async onLike(event)
  {
    if(!this.isLikeClickable) return
    this.isLikeClickable = false;
    let userId = this.club.cid;
    this.fireData.database.ref(`/posts/${this.postId}/likes/${userId}`).once("value", (result) => {
      console.log("result: ", result.val());
      if (!result.val())
      {
        this.fireData.database.ref(`/posts/${this.postId}/likes/${userId}`).set(this.authorId).then((result) => {
          this.fireData.database.ref(`/server-process`).child('likes').child(this.postId).child(userId).child(this.authorId).set(true).then(result => { console.log("liked", result);this.isLikeClickable = true;});
        });
      }
      else {
        this.fireData.database.ref(`/posts/${this.postId}/likes/${userId}`).set(null).then((result) => {
          this.fireData.database.ref(`/users-posts/${this.authorId}/${this.postId}/likesCount`).once("value", (result) => {
            let likesCount = result.val();
            if(likesCount >=0)
            this.fireData.database.ref(`/users-posts/${this.authorId}/${this.postId}/likesCount`).set(likesCount - 1);
            this.isLikeClickable = true;
          });
        });
      }
    });
  }

  async checkLiked()
  {
    let userId = this.club.cid;
    return  await this.fireData.object(`/posts/${this.postId}/likes/${userId}`);
  }

  async onComment(event)
  {
    let postComment = {
        author: this.club.cid,
        date: (new Date()).valueOf()/1000,
        text: this.comment,
        mentioned: this.mentionedInComment
      }  
    await this.fireData.database.ref(`/posts/${this.postId}/comments/`).push(postComment).then(result => {
      let commentId = result["path"]["o"][result["path"]["o"].length - 1];
      this.fireData.database.ref(`/server-process/comments/${this.authorId}/${this.postId}/${commentId}`).set(this.club.cid).then((result => {
        console.log("server-process: comment successfull");
        this.parentSubject.next({ text: "" });
      }));
    });
  }

  showEditBox: boolean = false;
  commentKeyToEdit;
  editCommentMentioned;
  commentToEdit;
  onShowEditBox(comment)
  {
    this.commentToEdit = comment;
    this.showEditBox = true;
    this.commentKeyToEdit = comment.$key;
    this.editCommentText = comment.text;
    this.editCommentMentioned = comment.mentioned
    
    if (!comment.mentioned)
    {
      setTimeout(() => {
        this.parentSubjectEdit.next({ text: comment.text });
      }, 100);
      }
    else {
      setTimeout(() => {
        this.editCommentMentioned = comment.mentioned
      this.parentSubjectEdit.next({ text: comment.text, mentioned: this.editCommentMentioned });
      }, 100);
      
    }
  }

  cancelEdit()
  {
    this.commentToEdit = {}
    this.showEditBox = false;
    this.commentKeyToEdit = "";
    this.show = false;
  }

  editCommentText:string = "";

  async editComment()
  {
    let comment = this.commentToEdit;
    console.log("update_comment", comment);
    let commentToEdit: any= new  Object();
    Object.assign(commentToEdit, comment)
    delete commentToEdit.author_avatar
    delete commentToEdit.author_name
    delete commentToEdit.author_website
     this.show = false;

    //to update comment
    this.fireData.database.ref(`/posts/${this.postId}/comments/${comment.$key}/text`).set(this.editCommentText).then(result => {
      if (this.editCommentMentioned)
      {
        this.fireData.database.ref(`/posts/${this.postId}/comments/${comment.$key}/mentioned`).set(this.editCommentMentioned).then(result => {
           this.showEditBox = false;
            this.editCommentText = "";
          this.editCommentMentioned = {};
          this.closeToggle();
        });
      }
      else {
          this.showEditBox = false;
          this.editCommentText = "";
        this.editCommentMentioned = {};
        this.closeToggle();
      }
    });
  }

  async deleteComment(comment)
  {
    this.fireData.database.ref(`/posts/${this.postId}/comments/${comment.$key}`).set(null).then(result => {
      console.log("comment removed from posts");
      this.fireData.database.ref(`/users-posts/${this.authorId}/${this.postId}/commentsCount`).once("value", (count) => {
        let commentCount = count.val() ? count.val() : 0;
        if (commentCount) commentCount = commentCount - 1;
        this.fireData.database.ref(`/users-posts/${this.authorId}/${this.postId}/commentsCount`).set(commentCount);
        this.closeToggle();
      });
    });
  }

  public changeTextMentioned(data: {
    text: string;
    mentioned: Array<any>;
  }): void {
    this.changeText(data.text);
    this.changeMentioned(data.mentioned);
  }

  public changeText(text: string): void {
    this.comment = text;
  }

  public changeMentioned(users: Array<any>): void {
    if (users.length) {
      this.post.mentioned = {};
      this.mentionedInComment = {}
      users.forEach((user) => {
        this.mentionedInComment[user.$key] = {
          username: user.username,
          type: user.type,
        };
      });
    }
  }

   public changeTextMentionedEdit(data: {
    text: string;
    mentioned: Array<any>;
   }): void {
    this.changeTextEdit(data.text);
    this.changeMentionedEdit(data.mentioned);
  }

  public changeTextEdit(text: string): void {
    this.editCommentText = text;
  }

  public changeMentionedEdit(users: Array<any>): void {
    if (users.length) {
      this.editCommentMentioned = {};
      users.forEach((user) => {
        this.editCommentMentioned[user.$key] = {
          username: user.username,
          type: user.type,
        };
      });
    }
  }
}
